<template>
  <div>
    <img class="image" :src="house" />
    <div class="fix-gradient">
      <div class="principle">${{FORMATED_PRINCIPLE}}</div>
    </div>
    <div class="sub-title">PRICE OF HOME</div>
    <slider
      class="slider"
      :value="state.PRINCIPLE"
      :min="min"
      :max="max"
      :interval="interval"
      :update="updatePrinciple"
    ></slider>
  </div>
</template>

<script>
import Slider from "./util/Slider";
import { checkValidation } from "../util/validate";
import { roundCurrency, roundDollarsToCents } from "../util/bankersRound";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { STATE, MUTATIONS, GETTERS, ACTIONS } from "../storeConstants";
import house from "../../public/house.svg";
import dollar from "../../public/dollar-sign.svg";

const { FORMATED_PRINCIPLE } = GETTERS;
const { CHANGE } = MUTATIONS;
const {
  UPDATE_TERM,
  UPDATE_PRINCIPLE,
  UPDATE_INTEREST_RATE,
  UPDATE_DOWNPAYMENT
} = ACTIONS;

export default {
  data: () => {
    return {
      dollar: dollar,
      house: house,
      max: 100000000,
      min: 100000,
      interval: 100
    };
  },
  computed: {
    ...mapState({
      state: state => state.base
    }),
    ...mapGetters([FORMATED_PRINCIPLE])
  },
  methods: {
    ...mapMutations([CHANGE]),
    ...mapActions([UPDATE_PRINCIPLE]),
    showValue(value, target, errorState) {
      return typeof this.state.ERRORS[target] === "undefined"
        ? value
        : errorState;
    },

    updatePrinciple(value) {
      checkValidation({
        state: this.state,
        change: this.CHANGE,
        target: "PRINCIPLE",
        value
      });
      const newPrinciple =
        typeof value === "object"
          ? roundDollarsToCents(
              parseInt(value.target.value.replace(/[^0-9.-]/g, ""), 10)
            )
          : value;
      if (!isNaN(newPrinciple)) {
        this.UPDATE_PRINCIPLE({ target: "PRINCIPLE", value: newPrinciple });
      }
    }
  },
  components: {
    Slider: Slider
  }
};
</script>
<style>
@import url("../../node_modules/vue-slider-component/theme/antd.css");
@import url("../../node_modules/vue-slider-component/dist-css/vue-slider-component.css");
</style>
<style scoped lang="scss">
.downpayment-slider {
  display: flex;
  justify-content: center;
  //  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  .fix-gradient {
    display: flex;
  }
  @media (min-width: 768px) {
    margin: 0;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
  }
  .image {
    margin-bottom: 20px;
    width: 143px;
    @media (min-width: 768px) {
      margin-bottom: 0px;
    }
  }
  @mixin gradient-text($start-color, $end-color, $fallback: #000) {
    color: $fallback;
    @supports (background-clip: text) {
      color: transparent;
      background-image: linear-gradient(to right, $start-color, $end-color),
        linear-gradient(to bottom, #fff, #fff);
      -webkit-background-clip: text;
      background-clip: text;
    }
  }
  .principle {
    @include gradient-text(#60c5b7, #acd14c);
    font-size: 38px;
    text-align: center;
    width: 100%;
    color: #60c5b7;
    font-family: "Poppins", sans-serif;
  }
  .sub-title {
    font-family: "Poppins", sans-serif;
    color: #808080;
    text-align: center;
    width: 100%;
    margin-bottom: 14px;
    font-size: 14px;
  }
  .slider {
    margin-bottom: 34px;
    @media (min-width: 768px) {
      margin-bottom: 0px;
    }
  }
}
</style>
<style lang="scss">
.vue-slider-rail {
  height: inherit;
}
</style>
